import { InfoIcon } from './InfoIcon';

interface InfoItemProps {
  title: string;
  tooltip?: string;
  align?: 'center' | 'end' | 'start';
  side?: 'bottom' | 'left' | 'right' | 'top';
}

export const InfoItem = ({ title, tooltip, align, side }: InfoItemProps) => {
  return (
    <div className='flex grow shrink basis-0 items-start gap-2 uppercase typography-body-graphik-xsmall font-graphik-condensed'>
      <span>{title}</span>
      {tooltip && (
        <InfoIcon
          align={align}
          side={side}
          tooltip={tooltip}
        />
      )}
    </div>
  );
};
